module.exports = __webpack_public_path__ + "static/media/StarCracks.a9043eb1.gif";